// NOTE: Legacy v2 flex/CourseManager path only. Do not add v3 curriculum features here.
// For learning experiences, please refer to components/HsIndividualResourceMarkComplete

import MarkCompleteSection from './container'
export default MarkCompleteSection
